module.exports = __webpack_public_path__ + "img/wxsphdg.0d394ee6.png";